module.exports = __webpack_public_path__ + "img/203.9848fd0d.png";